import React, { Component } from "react"
import "./Login.css"
import shop from "../../shop/shop"
import { browserHistory } from "react-router"

class LogoutPage extends Component {
  constructor() {
    super()
    this.state = {
      user    : "",
      password: ""
    }
    shop.logout()
      .then( shop.whoami )
      .then( () => {
        return shop.cart.reset()
      } )
      .then( () => {
        document.location = "/"
      } )
  }
  
  render() {
    // browserHistory.push("/login") => Let whoami + custom logic handle the redirecting
    return (
      <div className="container">
        <div className="tc pa4">Ihre Session wird beendet.</div>
      </div>
    )
  }
}

export default LogoutPage


// WEBPACK FOOTER //
// ./src/theme/pages/LogoutPage.js